import { apolloClient } from '~/apollo-client';
import {
  Flex_FetchLmiProofDocsQuery,
  Flex_FetchLmiProofDocsQueryVariables,
} from '~/typings/graphql';
import { FETCH_LMI_PROOF_DOCS } from './fetch-lmi-proof-docs.queries';

export type FetchLMIProofDocsParams = {
  id: number;
};

export type FetchLMIProofDocsResponse = {
  lmiProofDocs: Array<{
    proofDocUrls: (string | null)[];
    proofDocName?: string | null | undefined;
    proofDocStatus?: string | null | undefined;
    uaLmiSourceTypeId?: number | null | undefined;
    utilityAccountId?: number | null | undefined;
    utilityAccountNumber?: string | null | undefined;
    utilityName?: string | null | undefined;
  }>;
};

export const fetchLMIProofDocs = async (
  params: FetchLMIProofDocsParams,
): Promise<FetchLMIProofDocsResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchLmiProofDocsQuery,
    Flex_FetchLmiProofDocsQueryVariables
  >({
    query: FETCH_LMI_PROOF_DOCS,
    variables: {
      userId: params.id,
    },
    fetchPolicy: 'no-cache',
  });
  const {
    lmiProofDocs,
  }: {
    lmiProofDocs: {
      proofDocUrls: (string | null)[];
      proofDocName?: string | null | undefined;
      proofDocStatus?: string | null | undefined;
      uaLmiSourceTypeId?: number | null | undefined;
      utilityAccountId?: number | null | undefined;
      utilityAccountNumber?: string | null | undefined;
      utilityName?: string | null | undefined;
    }[];
  } = data.user as {
    lmiProofDocs: {
      proofDocUrls: (string | null)[];
      proofDocName?: string | null | undefined;
      proofDocStatus?: string | null | undefined;
      uaLmiSourceTypeId?: number | null | undefined;
      utilityAccountId?: number | null | undefined;
      utilityAccountNumber?: string | null | undefined;
      utilityName?: string | null | undefined;
    }[];
  };
  return {
    lmiProofDocs,
  };
};
